// main.js

import { initNavigation } from './_navigation.js';
import { initAllVars, setHeaderHeight, setFooterHeight } from './_initVars.js';
import { initLenis, syncLenisWithGSAP, getLenis } from './_lenis.js';
import { initGSAP, getGSAP } from './_gsap.js';
import { initSmoothLettersAnimation } from './_textAnimations.js';
import { initParallaxAnimations } from './_parallaxAnimations.js';
import { initViewportAnimations } from './_viewportAnimations.js';
import { initParagraphAnimations } from './_paragraphAnimations.js';
import { initParagraphRevealAnimations } from './_paragraphRevealAnimations.js';
import { initContactForm } from './_contactForm.js';
import { initLoader } from './_loader.js';

// Nouvelle fonction pour scroller vers le haut
function scrollToTop() {
  const lenis = getLenis();
  if (lenis) {
    lenis.scrollTo(0, { immediate: true });
  } else {
    window.scrollTo(0, 0);
  }
}

// Fonction pour initialiser les fonctionnalités communes à toutes les pages
function initCommonFunctionalities() {
  const gsap = getGSAP();
  
  // Cacher le contenu principal initialement
  gsap.set('#app', { opacity: 0 });

  initLoader();

  // Attendre que le loader soit terminé avant d'initialiser le reste
  document.addEventListener('loaderFinished', () => {
    initNavigation();
    initAllVars();
    initLenis();
    initGSAP();
    
    // Synchroniser Lenis avec GSAP
    syncLenisWithGSAP(gsap);
    
    // Initialiser les animations
    initSmoothLettersAnimation();
    initParallaxAnimations();
    initViewportAnimations();
    initParagraphAnimations();
    initParagraphRevealAnimations();
    
    // Afficher le contenu principal
    gsap.to('#app', { opacity: 1, duration: 0.5 });

    window.addEventListener('resize', () => {
      setHeaderHeight();
      setFooterHeight();
    });

    // Scroller vers le haut après l'initialisation
    scrollToTop();
  });
}

// Fonction pour initialiser les fonctionnalités spécifiques à la page d'accueil
function initHomePage() {
  
  // Ajoutez ici les initialisations spécifiques à la page d'accueil
}

// Fonction pour initialiser les fonctionnalités spécifiques à la page des travaux
function initWorksPage() {
  
  // Ajoutez ici les initialisations spécifiques à la page des travaux
}

// Fonction pour initialiser les fonctionnalités spécifiques à la page des travaux
function initContactPage() {
  initContactForm();
  // Ajoutez ici les initialisations spécifiques à la page des travaux
}

// Fonction principale qui détermine quelle page est chargée et initialise les fonctionnalités appropriées
function init() {
  initCommonFunctionalities();

  // Déterminez quelle page est actuellement chargée
  const currentPage = document.body.id;

  switch(currentPage) {
    case 'p-home':
      initHomePage();
      break;
    case 'p-works':
      initWorksPage();
      break;
    case 'p-contact':
      initContactPage();
      break;
    // Ajoutez d'autres cases pour les autres pages si nécessaire
    default:
      
  }
}

// Exécutez la fonction init lorsque le DOM est complètement chargé
document.addEventListener('DOMContentLoaded', init);

// Ajoutez ces lignes pour s'assurer que le scroll vers le haut se fait à chaque chargement de page
window.addEventListener('load', scrollToTop);